/**
 * ****************************************************************************
 * @description     :   Route for gs module
 * @created at      :   2023/10/05
 * @created by      :   ANS892 – baonhp@ans-asia.com
 * @package         :   STworks
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import component of view
 */
const pj0040i = () => import('@/views/pj/pj0040i');
const pj0010i = () => import('@/views/pj/pj0010i');

/**
 * Defined Router
 */
const resource = 'pj';

export default [
    {
        path: `/${resource}/pj0040i`,
        name: 'pj0040i',
        component: pj0040i,
        meta: {
            title: 'プロジェクトの実績'
        }
    },
    {
        path: `/${resource}/pj0010i`,
        name: 'pj0010i',
        component: pj0010i,
        meta: {
            title: 'プロジェクトの管理'
        }
    }
];
